import React from "react"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"

export default function ContactList({ data, locale }) {
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])

  return (
    <section className="sc-contact-list" ref={trigger}>
      <div className="container">
        <p className={`label ${anim(1)}`}>{translations[`ask_us_${locale}`]}</p>
        <div className="row contact-list">
          {data?.map((item, i) => (
            <div className={`col-md-6 ${anim(2 + i)}`} key={`contact-${i}`}>
              <div className="contact-item">
                <p className="title">{item[`title_${locale}`]}</p>
                {item.email ? (
                  <Link
                    target="_blank"
                    href={`mailto:${item.email}`}
                    className="email-text"
                  >
                    <i className="air ai-envelope" /> {item.email}
                  </Link>
                ) : null}
                {item.phone ? (
                  <Link
                    target="_blank"
                    href={`tel:${item.phone}`}
                    className="phone-text"
                  >
                    <i className="air ai-phone-alt" /> {item.phone}
                  </Link>
                ) : null}
                {item.whatsapp ? (
                  <Link
                    target="_blank"
                    href={`https://wa.me/${item.whatsapp}`}
                    className="whatsapp-text"
                  >
                    <i className="aib ai-whatsapp" /> {item.whatsapp}
                  </Link>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
